@if (form()) {
<mat-card [formGroup]="form()">
  <input
    type="hidden"
    formControlName="assessmentCoordinator" />
  <input
    type="hidden"
    formControlName="legalUnitResponsibles" />
  <mat-card-content>
    <h3>Auditee*</h3>
    <mat-list>
      <mat-list-item
        >{{ form().get('assessmentCoordinator')?.value | userName: form().get('assessmentCoordinatorName')?.value | async }}
        {{ form().get('assessmentCoordinator')?.value | azureIdStatus | async }}</mat-list-item
      >
    </mat-list>
    @if (chkError('assessmentCoordinator')) {
    <mat-error> Choose an Auditee </mat-error>
    }
    <h3>LU responsibles*</h3>
    <mat-list>
      @if (form().get('legalUnitResponsibles')?.value.length === 0) {
      <mat-list-item> NONE </mat-list-item>
      } @for (id of form().get('legalUnitResponsibles')?.value; track id; let i = $index) {
      <mat-list-item>{{ id | userName: form().get('legalUnitResponsiblesNames')?.value?.[i] | async }} {{ id | azureIdStatus | async }} </mat-list-item>
      }
    </mat-list>
    @if (chkError('legalUnitResponsibles')) {
    <mat-error> Choose LU responsibles </mat-error>
    }
    <h3>Others</h3>
    <mat-list>
      @if (form().get('otherResponsibles')?.value.length === 0) {
      <mat-list-item> NONE </mat-list-item>
      } @for (id of form().get('otherResponsibles')?.value; track id; let i = $index) {
      <mat-list-item> {{ id | userName: form().get('otherResponsibleNames')?.value?.[i] | async }} {{ id | azureIdStatus | async }} </mat-list-item>
      }
    </mat-list>
    @if (editable()) {
    <button
      class="changeResp"
      mat-raised-button
      (click)="openDialog()">
      Check & change Responsibles
    </button>
    } @if (showCompleteResponsibles()) {
    <button
      class="changeResp"
      mat-raised-button
      (click)="completeResponsibles()">
      Basic definitions complete
    </button>
    }
  </mat-card-content>
</mat-card>
}
